module.exports = __webpack_public_path__ + "static/media/testCustomerInventory_logo.64c1c2b2.png";